import { ObjectStrings } from './types/commonTypes';

const env = process.env.BACK_ENV || 'optimus';

export const IS_LOCAL = process.env.CI_ENV === 'local';

const definedEnvs: {
  [key: string]: ObjectStrings;
} = {
  prod: {
    API_URL: 'https://support-backend.usrsprt.com/api/chat',
    SOCKET_URL: 'https://support-backend.usrsprt.com',
    SUPPORT_BACKEND_API: 'https://support-backend.usrsprt.com/support/workflow',
    SUPPORT_ROUTE: 'https://help.airslate.com',
    PUSHER_KEY: 'romario',
    SCREEN_SHARE_URL: 'https://screenshare.usrsprt.com',
  },
  rc: {
    API_URL: 'https://support-backend.usrsprt-rc.xyz/api/chat',
    SOCKET_URL: 'https://support-backend.usrsprt-rc.xyz',
    SUPPORT_BACKEND_API: 'https://support-backend.usrsprt-rc.xyz/support/workflow',
    SUPPORT_ROUTE: 'https://help.airslate-stage.xyz',
    PUSHER_KEY: 'supervisor',
    SCREEN_SHARE_URL: 'https://screenshare.usrsprt-rc.xyz',
  },
};

const DEV_TEMPLATES = {
  API_URL: 'https://support-backend-{dev}.usrsprt.xyz/api/chat',
  SOCKET_URL: 'https://support-backend-{dev}.usrsprt.xyz',
  SUPPORT_BACKEND_API: 'https://support-backend-{dev}.usrsprt.xyz/support/workflow',
  SUPPORT_ROUTE: 'https://help-dev.airslate-stage.xyz',
  PUSHER_KEY: 'supervisor',
  SCREEN_SHARE_URL: 'https://screenshare-{dev}.usrsprt.xyz',
};

let currentEnv: ObjectStrings = {};

if (definedEnvs[env]) {
  currentEnv = definedEnvs[env];
} else {
  currentEnv = Object.entries(DEV_TEMPLATES).reduce((envObject: ObjectStrings, [key, value]) => {
    envObject[key] = value.replace(/\{dev\}/g, env);
    return envObject;
  }, {});
}

export const {
  API_URL = '',
  SOCKET_URL = '',
  SUPPORT_BACKEND_API = '',
  SUPPORT_ROUTE = '',
  PUSHER_KEY = '',
  SCREEN_SHARE_URL = '',
} = currentEnv;

export const publicPath = process.env.ASSET_PATH || '/';
